import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";

import {
  callAPI,
  getLocalValue,
  LoacalVariables,
  Method
} from "../../commonFunctions/CommonFunctions";
import { Header, IHeaderActions } from "../../Components/Header/Header";
import { resetDataComponent } from "../../StateManagement/actions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import { UpdateStatus } from "../components/UpdateStatus";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import config from '../../Config/clientConfig.json';
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";

const LoanList: React.FC<any> = React.memo(() => {
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  const navigate = useNavigate();
  const userType = getLocalValue(LoacalVariables.UserType);
  breadCrumbsStore.updateBreadCrumbs([{ "Loan Requests": "/loan/requests/list" }]);

  const [isPopupOpen, setPopupOpen] = React.useState(false); //for delete;
  const [selectedIdForDlt, setSelectedIdForDlt] = React.useState<any>(null);
  const [loanId, setLoanId] = React.useState(null);

  const [edit, setEdit] = useState(null);
  // const [loadingRegion, setLoadingRegion] = React.useState(false);
  const [districtOptions, setDistrictOptions] = React.useState<any[]>([]);
  const [blockOptions, setBlockOptions] = React.useState<any[]>([]);
  const [cdsOptions, setCdsOptions] = React.useState<any[]>([]);
  // const [loanTypeOptions, setLoanTypeOptions] = React.useState<any[]>([]);

  const source = {
    url: "loans/search",
    page: 1,
    pageSize: 10,
    filter: [
      { field: "status", operator: "eq", value: 'pending' }
    ],
    sort: []
  };

  useEffect(() => {
    if (userType === "admin") {
      fetchDistricts();
      fetchBlocks();
      fetchCDS();
    } else if (userType === "district") {
      const districtId = getLocalValue(LoacalVariables.District);
      if (districtId) {
        fetchBlocks(districtId);
      }
    } else if (userType === 'block') {
      fetchCDS();
    }
  }, []);

  const fetchDistricts = async () => {
    try {
      const res = await callAPI("districts/getAll", Method.GET);
      setDistrictOptions(
        res?.data?.map((d: any) => ({ label: d.name, value: d._id })) || []
      );
    } catch (error) {
      console.error("Failed to fetch districts:", error);
      showMessage("Failed to load districts", "error");
    }
  };

  const fetchBlocks = async (districtId?: string) => {
    try {
      // setLoadingRegion(true);
      // const res = await callAPI(`blocks/byDistrict/${districtId}`, Method.GET);
      const res = await callAPI('blocks/getAll', Method.GET);

      setBlockOptions(
        res?.data?.map((b: any) => ({ label: b.name, value: b._id })) || []
      );
    } catch (error) {
      console.error("Failed to fetch blocks:", error);
      showMessage("Failed to load blocks", "error");
    } finally {
      // setLoadingRegion(false);
    }
  };

  const fetchCDS = async (blockId?: string) => {
    try {
      // const res = await callAPI(`cds/byBlock/${blockId}`, Method.GET);
      const res = await callAPI('cds/getAll', Method.GET);
      setCdsOptions(
        res?.data.map((c: any) => ({ label: c.name, value: c._id })) || []
      );
    } catch (error) {
      console.error("Failed to fetch CDS:", error);
      showMessage("Failed to load CDS", "error");
    }
  };

  // const fetchLoanTypes = async () => {
  //   try {
  //     // const res = await callAPI(`cds/byBlock/${blockId}`, Method.GET);
  //     const res = await callAPI('loanTypes/getAll', Method.GET);
  //     setLoanTypeOptions(
  //       res?.data.map((c: any) => ({ label: c.name, value: c._id })) || []
  //     );
  //   } catch (error) {
  //     console.error("Failed to fetch CDS:", error);
  //     showMessage("Failed to load CDS", "error");
  //   }
  // };

  let limitedActions;
  switch (userType) {
    case 'admin':
    case 'district':
      limitedActions = ["Sanction", "Delete", "View", "Activity Logs"];
      break;
    case 'block':
      limitedActions = ["Edit", "Delete", "View"];
      break;
    case 'cds':
      limitedActions = ["View"];
      break;
    default:
      limitedActions = ["View"];
  }

  //edit / delete or perform other actions.
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      setEdit(row);
      navigate(`/loan/request/${row?._id}`)
    } else if (action === "Delete") {
      setPopupOpen(true);
      setSelectedIdForDlt(row?._id);
    } else if (action === "Activity Logs") {
      navigate(`/loan/activityLogs/${row?._id}`)
    } else if (action === "View") {
      navigate(`/loan/detail/${row?._id}`)
    }
    else if (action === 'Sanction') {
      navigate(`/loan/request/sanction/${row?._id}`)
    }
  };


  const handleStatus = async (data: any) => {
    try {
      const response: any = await saveData(data);
      setLoanId(null);

      if (response && response?.message) {
        dispatch(resetDataComponent("loanGrid"));
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
      }
    } catch (e: any) {
      showMessage(e.response?.data?.message || "An unexpected error occurred", "error");
    } finally {
      setLoanId(null);
    }
  };

  const metadataStatus: IMetaData = {
    title: "Update Status",
    hideActions: false,
    content: (props: any, row: any) => <UpdateStatus {...props} config={config.loanStatusConfig.staticOptionData} />,
    actions: [
      {
        label: "Cancel",
        className: "ws-cancel",
        type: "button"
      },
      {
        label: "Submit",
        onClick: handleStatus,
        type: "submit",
        autoFocus: true
      }
    ],
    isDragable: true
  };

  const saveData = async (data: any) => {
    const request: any = {
      status: data?.newStatus,
    };

    const response: any = await callAPI(
      `loans/update/status/${loanId}`,
      Method.PATCH,
      request
    );
    
    return response;
  };

  const handleCloseDialog = (data?: any) => {
    setLoanId(null);
  };

  React.useEffect(() => {
    if (loanId) {
      openPopUp(metadataStatus, handleStatus, "40rem", handleCloseDialog);
    }
  }, [loanId]);

  const handleDelete = () => {
    dispatch(resetDataComponent("loanGrid"));
    showMessage("Loan deleted successfully!", "success");
  };

  const handleClick = () => {
    navigate('/loan/request')
  };


  const columns: IColumns[] = [
    {
      header: "Loan ID",
      fieldName: "loanId",
      tooltip: true,
      sortable: true
    },

    {
      header: "Enterprise",
      fieldName: "enterpriseName",
      tooltip: true,
      sortable: true
    },

    {
      header: "Applied Amount",
      fieldName: "appliedAmount",
      tooltip: true,
      sortable: true,
      type: "currency"
    },

    {
      header: userType === 'district' || userType === "admin" ? "Block" : "CDS",
      fieldName: userType === 'district' || userType === "admin" ? "block.name" : "cds.name",
      tooltip: true,
      type: "default"
    },

    {
      header: "Group Loan",
      fieldName: "isGroupLoan", // assuming the field is 'isGroupLoan'
      tooltip: true,
      sortable: true,
      type: 'default',
      render: (row: any) => row.isGroupLoan ? "Yes" : "No",  // converting true/false to Yes/No
    },

    {
      header: "Status",
      fieldName: "status",
      tooltip: true,
      type: "status"
    },

    {
      header: "Date",
      fieldName: "createdAt",
      type: "date",
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: limitedActions,
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const filterFields = [
    { type: "text", fieldName: "loanId", label: "Loan ID" },
    { type: "text", fieldName: "applicantName", label: "Applicant Name", operator: "regex" },
    { type: "text", fieldName: "secondApplicantName", label: "Second Applicant Name" },
    { type: "text", fieldName: "mobile", label: "Mobile Number", operator: "regex" },
    { type: "text", fieldName: "whatsappNumber", label: "WhatsApp Number", operator: "regex" },
    { type: "text", fieldName: "enterpriseName", label: "Enterprise Name", operator: "regex" },
    { type: "text", fieldName: "referenceNumber", label: "Reference Number", operator: "eq" },

    // { type: "dropdown", fieldName: "loanType", label: "Loan Type", options: loanTypeOptions },
    // { type: "dropdown", fieldName: "district", label: "District", options: districtOptions },
    userType == 'district' && { type: "dropdown", fieldName: "block", label: "Block", options: blockOptions },
    { type: "dropdown", fieldName: "cds", label: "CDS", options: cdsOptions },

    // { type: "date", fieldName: "sanctionedDate", label: "Sanctioned Date" },
    // { type: "date", fieldName: "fundTransferDate", label: "Fund Transfer Date" },

    {
      type: "dropdown", fieldName: "status", label: "Status", options: [
        { label: "Pending", value: "pending" },
        // { label: "Approved", value: "approved" },
        { label: "Rejected", value: "rejected" },
        // { label: "Sanctioned", value: "sanctioned" }
      ]
    },
  ];


  const action: IHeaderActions = {
    type: "button",
    text: "+ New Loan Request",
    size: "medium",
    onClick: handleClick,
    variant: "contained",
    color: "primary",
    sx: {
      textTransform: "none",
      color: "white",
      borderImage: "linear-gradient(95.53deg, #4DD26B 0%, #08B1B6 99.12%)",
      borderImageSlice: 1,
      backgroundImage: "linear-gradient(95.53deg, #4DD26B 0%, #08B1B6 99.12%)",
      "&:hover": {
        backgroundImage: "linear-gradient(95.53deg, #4DD26B 0%, #08B1B6 99.12%)",
        opacity: 0.9,
      },
    }
  };

  return (
    <>
      <Helmet>
        <title>Loans | Willsoar Technologies</title>
        <meta
          name="description"
          content="Manage all loans in one place. View, add, or edit loan information easily."
        />
      </Helmet>
      <Grid p={2}>
        {userType === "block" ? <Header
          type="new"
          title="Loans"
          id={"loanHeader"}
          action={action}
        // icon={<WSIcons.Document fontSize="medium" color="#7D79C2" />}
        /> : <Header
          type="new"
          title="Loans"
          id={"loanHeader"}
        // icon={<WSIcons.Document fontSize="medium" color="#7D79C2" />}
        />}

        <Grid container spacing={2} mb={6}>
          <Grid item xs={12}>
            <WSDataGrid
              id="loanGrid"
              columns={columns}
              source={source}
              filterFields={filterFields}
              filters={[{ field: "status", operator: "eq", value: 'pending' }]}
              searchBox={{ fieldName: "mobile", type: "number" }}
              placeholder={"Search by Mobile Number"}
              exportCsv
              buttonStyle="Sigma"
            />
          </Grid>
        </Grid>

        {isPopupOpen && (
          <ConfirmationPopup
            apiUrl={"loans/delete"}
            id={selectedIdForDlt}
            confirmMessage="Are you sure you want to delete this loan?"
            subtitle="This action cannot be undone"
            open={isPopupOpen}
            onClose={() => setPopupOpen(false)}
            onConfirm={handleDelete}
            permanent
          />
        )}
      </Grid>
    </>
  );
});


export default LoanList;